export const safeCurrencyFormat = (amount, currency = "USD", options = {}) => {
    const num = Number(amount);
    if (isNaN(num)) return amount;

    const { compactThreshold = null } = options;
    const abs = Math.abs(num);
    const isCompact = compactThreshold !== null && abs >= compactThreshold;
    const sign = num < 0 ? "-" : "";

    let symbol = "";
    try {
        const sample = new Intl.NumberFormat("en-NG", {
            style: "currency",
            currency,
            currencyDisplay: "symbol",
            minimumFractionDigits: 0,
        }).format(0);
        symbol = sample.replace(/[0-9\s.,]/g, "");
    } catch (e) {
        symbol = "";
    }

    if (isCompact) {
        let compactStr = "";
        if (abs >= 1e9) {
            compactStr = (abs / 1e9).toFixed(1).replace(/\.0$/, "") + "B";
        } else if (abs >= 1e6) {
            compactStr = (abs / 1e6).toFixed(1).replace(/\.0$/, "") + "M";
        } else if (abs >= 1e3) {
            compactStr = (abs / 1e3).toFixed(1).replace(/\.0$/, "") + "k";
        } else {
            compactStr = abs.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            });
        }

        if (symbol) {
            return `${sign}${symbol}${compactStr}`;
        }
        return `${sign}${compactStr} ${currency}`;
    }

    try {
        return new Intl.NumberFormat("en-NG", {
            style: "currency",
            currency,
            currencyDisplay: "symbol",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(num);
    } catch (e) {
        // For unsupported currencies like USDT/USDC
        const formattedNum = abs.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
        return `${sign}${formattedNum} ${currency}`;
    }
};
